"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("spry-react/Grid/gridStyles");
var pager_1 = require("spry-react/Pager/pager");
var pagerModel_1 = require("spry-react/Pager/pagerModel");
function GridFooter(props) {
    if (props.pagerSettings || props.resultsMessage) {
        var resultsMessage = props.resultsMessage
            ? React.createElement("div", { className: 'grid-results-message' }, props.resultsMessage)
            : null;
        var pager = props.pagerSettings && props.pageSelectedHandler
            ? React.createElement(pager_1.Pager, { model: new pagerModel_1.PagerModel(props.pagerSettings, props.pageSelectedHandler, props.maxPageButtons) })
            : null;
        return (React.createElement("div", { className: styles.gridFooter + " l-box-vt-1-2x" },
            resultsMessage,
            React.createElement("div", { className: styles.pager }, pager)));
    }
    return null;
}
exports.GridFooter = GridFooter;
